import React, { useState } from "react";
import { AnimatePresence } from "framer-motion"

//Styles
import {
    Container,
    PaymentItemContainer,
    PaymentOrder,
    PaymentOrderDate,
    DetailsPaymentContainer,
    StatusContainer,
    Status,
    PlanDescriptionAndButton,
    PaymentTitleText,
    PlanDescritionText,
    Button
} from "./styles";

//Interface
import { PaymentItemPropsInterface } from "./interfaces";

//Assets
import check from "../../assets/icons/check-green.svg";
import cancel from "../../assets/icons/cancel.svg";

const PaymentItem = (props: PaymentItemPropsInterface) => {
    const [isOpen, setIsOpen] = useState(false)

    const generateImgIconPaymentStatus = () => {
        const objIcons = {
            paid: <img src={check} alt="V"/>,
            pending: <></>
        } 

        return objIcons[props.status as keyof typeof objIcons] 
            ?? <img src={cancel} alt="X"/>
    }

    const statusTranslate = () => {
        const objStatus = {
            paid: "Aprovado",
            pending: "Pendente",
        }

        return objStatus[props.status as keyof typeof objStatus] 
            ?? "Recusado" 
    }

    return(
        <Container onClick={() => setIsOpen(!isOpen)}>
            <PaymentItemContainer status={props.status} layout>
                <div style={{display: "flex", alignItems: "center"}}>
                    <PaymentOrder>{ props.order }</PaymentOrder>
                    { generateImgIconPaymentStatus() }
                </div>
                <PaymentOrderDate>{props.transactionDate}</PaymentOrderDate>
            </PaymentItemContainer>
            <AnimatePresence>
                {isOpen &&
                    (
                        <DetailsPaymentContainer
                            status={props.status}
                            layout
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <hr style={{width: "80%", margin: 0}}/>
                            </div>
                            <StatusContainer>
                                <Status status={props.status}>
                                    { statusTranslate() }
                                </Status>
                            </StatusContainer>
                            <PlanDescriptionAndButton>
                                <div>
                                    <PaymentTitleText>Pagamento</PaymentTitleText>
                                    <PlanDescritionText>{props.subscriptionDescription}</PlanDescritionText>
                                </div>
                            </PlanDescriptionAndButton>
                        </DetailsPaymentContainer>
                    )
                }
            </AnimatePresence>
        </Container>
    )
}

export default PaymentItem;